import React, { useState, useEffect } from 'react';
import Footerdiv from "../layout/footer.js";
import Headerdiv from "../layout/header.js";
import {
  Layout,
  Typography,
  Descriptions,
  Card,
  Button,
  Space,
  Breadcrumb,
  Spin,
  Tag,
  Divider,
  Row,
  Col,
  theme,
  Modal
} from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { MAINAPIURL, APPBACKGROUND_COLOR, COMPANYLOGO } from '../appsettings.js';
import { AlertError, AlertSuccess } from '../usableclasses.js';
import { Page, Text, View, Document, StyleSheet, PDFViewer, Image } from '@react-pdf/renderer';
import { Table, TR, TH, TD } from '@ag-media/react-pdf-table';
import { Link } from 'react-router-dom';
import printlogo from '../printpropertise/printlogoceylonika.png';
import Html from 'react-pdf-html';

const { Title } = Typography;
const { Content } = Layout;

const PurchaseOrderPrint = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const ApiURL = MAINAPIURL;
  const TOKEN = localStorage.getItem("AUTHCODE");
  const UPDATED_BY = localStorage.getItem("USERID");

  const { token: { colorBgContainer, borderRadiusLG }, } = theme.useToken();

  const [purchaseOrder, setPurchaseOrder] = useState(null);
  const [poItems, setPoItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [itemsLoading, setItemsLoading] = useState(true);

  // Format date helper function
  const formatDate = (dateString) => {
    if (!dateString) return '';
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString();
    } catch (e) {
      return dateString;
    }
  };
  const styles = StyleSheet.create({
    page: {
      padding: 20,
      fontSize: 10,
      fontFamily: 'Helvetica',

    },
    row: { flexDirection: 'row', justifyContent: 'space-between', marginBottom: 10 },
    logo: { width: 150, height: 50 },
    companyInfo: { marginLeft: 10 },
    sectionBox: {
      // border: '1 solid #000',
      borderRadius: 5,
      marginBottom: 5,
      width: '48%',
      backgroundColor: '#edfcfc',
    },
    sectionBoxHeader: {
      borderRadius: 5,
      padding: 10,
      backgroundColor: '#a0fae8',
    },
    sectionBoxContent: {
      padding: 10,
    },
    table: {
      border: '1 solid #a0fae8',
      marginVertical: 10,
    },
    tableHeader: {
      padding: 5,
      flexDirection: 'row',
      borderBottom: '1 solid ',
      backgroundColor: '#a0fae8',
      fontWeight: 'bold',
    },
    tableRow: {
      padding: 5,
      flexDirection: 'row',
      borderBottom: '1 solid white',
      backgroundColor: '#edfcfc',
    },
    cell: { flex: 1, padding: 3 },
    centeredCell: { flex: 1, padding: 2, textAlign: 'center' },
    leftCell: { flex: 1, padding: 2, textAlign: 'left', width: "20%" },
    rightCell: { flex: 1, padding: 2, textAlign: 'right' },
    noteTaxRow: { flexDirection: 'row', justifyContent: 'space-between', marginTop: 10 },
    signatureSection: { marginTop: 30, flexDirection: 'row', justifyContent: 'space-between' },
    footer: {
      position: 'absolute', margin: '0 10', bottom: 10, left: 0, right: 0, textAlign: 'center', fontSize: 9, borderTop: '1 solid #c3c3c3', padding: 5,
    },
  });
  useEffect(() => {
    const fetchPurchaseOrderDetails = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${ApiURL}/purchase/getpoheaderdetails/${id}`, {
          headers: { SystemAccessToken: TOKEN }
        });

        if (response.data) {
          setPurchaseOrder(response.data);
        } else {
          AlertError('Failed to load purchase order data');
        }
      } catch (error) {

        AlertError('Error loading purchase order details');
      } finally {
        setLoading(false);
      }
    };

    const fetchPurchaseOrderItems = async () => {
      setItemsLoading(true);
      try {
        const response = await axios.get(`${ApiURL}/purchase/getpoitemdetails/${id}`, {
          headers: { SystemAccessToken: TOKEN }
        });

        if (response.data) {
          setPoItems(Array.isArray(response.data) ? response.data : []);
        } else {
          AlertError('Failed to load purchase order items');
        }
      } catch (error) {

        AlertError('Error loading purchase order items');
      } finally {
        setItemsLoading(false);
      }
    };

    if (id) {
      fetchPurchaseOrderDetails();
      fetchPurchaseOrderItems();
    }
  }, [id, ApiURL, TOKEN]);


  return (
    <Layout style={{ backgroundColor: APPBACKGROUND_COLOR }}>
      <Headerdiv />
      <Content style={{ padding: '10px' }}>

        <Breadcrumb style={{ margin: "16px 0" }}>
          <Breadcrumb.Item><Link to="/polist">Purchase Orders</Link></Breadcrumb.Item>
          <Breadcrumb.Item>Purchase Order Print</Breadcrumb.Item>
        </Breadcrumb>



        <div style={{ padding: 20, minHeight: '65vh', background: colorBgContainer, borderRadius: borderRadiusLG }}>
          <Space direction="vertical" style={{ width: "100%", padding: "15px" }}>

            {loading ? (
              <div style={{ textAlign: 'center', padding: '50px' }}>
                <Spin size="large" />
                <div style={{ marginTop: 16 }}>Loading purchase order details...</div>
              </div>
            ) : purchaseOrder ? (
              <>
                <PDFViewer width={"100%"} height={"500px"}>
                  <Document title={`PO-${purchaseOrder.poReferance}`} subject={`PO-${purchaseOrder.poReferance}`}>
                    <Page size="A4" style={styles.page} wrap>

                      <View style={styles.row}>
                        <View style={{ flexDirection: 'column', flex: 1 }}>
                          <Image src={printlogo} style={styles.logo} />
                          <View style={styles.companyInfo}>
                            <Text>Ceylonika Cosmetics (Pvt) Ltd</Text>
                            <Text>154/11, Pushparama Road, Kadawatha</Text>
                            <Text>www.ceylonikacosmetics.com | info@ceylonikacosmetics.com</Text>
                            <Text>+94 112 92 44 20</Text>
                          </View>
                        </View>

                        <View style={{ textAlign: 'right' }}>
                          <Text style={{ fontSize: 16, fontWeight: 'bold', paddingBottom: 5 }}>PURCHASE ORDER</Text>
                          <Text>PO Reference : {purchaseOrder.poReferance || '#xxxxxxx'}</Text>
                          <Text>Date : {formatDate(purchaseOrder.createdDate) || '__/__/20__'}</Text>
                          <Text>Created By : {purchaseOrder.createdBy || '--'}</Text>
                          <Text>PO Status : {purchaseOrder.currentStage || '--'}</Text>
                        </View>
                      </View>


                      <View style={styles.row}>
                        <View style={styles.sectionBox}>
                          <View style={styles.sectionBoxHeader}>
                            <Text style={{ fontWeight: 'bold' }}>Vendor Details</Text>
                          </View>
                          <View style={styles.sectionBoxContent}>
                            <Text>Name: {purchaseOrder.vendorName || ''}</Text>
                            <Text>Ref. No: {purchaseOrder.vendorBillNo || ''}</Text>
                            <Text>Ref. Date: {formatDate(purchaseOrder.vendorBillDate) || ''}</Text>
                          </View>

                        </View>
                        <View style={styles.sectionBox}>
                          <View style={styles.sectionBoxHeader}>
                            <Text style={{ fontWeight: 'bold' }}>Shipment Delivery Address</Text>
                          </View>
                          <View style={styles.sectionBoxContent}>
                            <Text>Ceylonika Cosmetics Central Warehouse</Text>
                            <Text>-</Text>
                            <Text>No 40, Siripala Road,</Text>
                            <Text>Kadawatha, Sri Lanka.</Text>
                          </View>


                        </View>
                      </View>


                      <View style={styles.table}>
                        <View style={styles.tableHeader}>
                          <Text style={styles.leftCell} width={"10%"}>Code</Text>
                          <Text style={styles.leftCell} width={"50%"}>Item</Text>
                          <Text style={styles.rightCell} width={"10%"}>Qty</Text>
                          <Text style={styles.rightCell} width={"15%"}>Cost Price</Text>
                          <Text style={styles.rightCell} width={"15%"}>Total Price</Text>
                        </View>
                        {poItems.map((item, index) => (
                          <View style={styles.tableRow} key={index}>
                            <Text style={styles.leftCell}>{item.itemSku}</Text>
                            <Text wrap={false} style={styles.leftCell}>{item.itemName}</Text>
                            <Text style={styles.rightCell}>{item.quantity}</Text>
                            <Text style={styles.rightCell}>{item.costPrice}</Text>
                            <Text style={styles.rightCell}>{item.totalCost}</Text>
                          </View>
                        ))}
                      </View>


                      <View style={styles.noteTaxRow}>
                        <View style={styles.sectionBox}>
                          <View style={styles.sectionBoxHeader}>
                            <Text style={{ fontWeight: 'bold' }}>Special Note</Text>

                          </View>
                          <View style={styles.sectionBoxContent}>
                            <Html style={{ fontSize: "10px" }}>{purchaseOrder.poNote}</Html>
                          </View>
                        </View>
                        <View style={styles.sectionBox}>
                          <View style={styles.sectionBoxHeader}>
                            <Text style={{ fontWeight: 'bold' }}>Final Summary</Text>
                          </View>
                          <View style={styles.sectionBoxContent}>
                            <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
                              <View>
                                <Text style={{ padding: '5' }} >Total Products Cost :</Text>
                                <Text style={{ padding: '5' }} >Total Vat (+) :</Text>
                                <Text style={{ padding: '5' }} >Total Taxes (+) :</Text>
                                <Text style={{ padding: '5' }} >Total Discount (-) :</Text>
                                <Text style={{ padding: '5' }} >Total Local Shipping (+) :</Text>
                                <Text style={{ padding: '5' }} >Total Int. Shipping (+) :</Text>
                                <Text style={{ padding: '5', fontWeight: 'bold' }} >Final Amount :</Text>
                              </View>
                              <View style={{ alignItems: 'flex-end' }}>
                                <Text style={{ padding: '5' }} >{purchaseOrder.totalProductCost || '0.00'}</Text>
                                <Text style={{ padding: '5' }} >{purchaseOrder.totalVat || '0.00'}</Text>
                                <Text style={{ padding: '5' }} >{purchaseOrder.totalTax || '0.00'}</Text>
                                <Text style={{ padding: '5' }} >{purchaseOrder.totalDiscount || '0.00'}</Text>
                                <Text style={{ padding: '5' }} >{purchaseOrder.totalShippingLocal || '0.00'}</Text>
                                <Text style={{ padding: '5' }} >{purchaseOrder.totalShippingInt || '0.00'}</Text>
                                <Text style={{ padding: '5', fontWeight: 'bold' }} >{purchaseOrder.totalPayable || '0.00'}</Text>
                              </View>
                            </View>
                          </View>
                        </View>

                      </View>


                      <View style={styles.signatureSection}>
                        <Text>Date: ............../................../..................</Text>
                        <Text>Signature: ___________________________</Text>
                      </View>

                      {/* Footer */}
                      <View style={styles.footer}>
                        <Text render={({ pageNumber, totalPages }) => (
                          `Page ${pageNumber} / ${totalPages}`
                        )} fixed />
                      </View>


                    </Page>
                  </Document>
                </PDFViewer>

              </>
            ) : (
              <div style={{ textAlign: 'center', padding: '50px' }}>
                <p>Purchase order not found</p>
              </div>
            )}

          </Space>
        </div>
      </Content>
      <Footerdiv />
    </Layout>
  );
};

export default PurchaseOrderPrint;
